import React from 'react';
import {connect} from 'react-redux'
import {PreviewButton, PreviewFooter} from 'react-weui'
import ErrorMessage from './ErrorMessage'
import axios from 'axios'


import '../../styles/messages/CardMessage.css'


class CardMessage extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            visible: Boolean(props.message.status),
            subscribed: false
        }
        this.onEnter = this.onEnter.bind(this)
        this.onSubscribe = this.onSubscribe.bind(this)
        this.onPay = this.onPay.bind(this)
        this.onFollowLiveroom = this.onFollowLiveroom.bind(this)
    }

    componentDidMount() {
        const {message, account} = this.props

        if (!this.state.visible) {
            this.context.classroomPage.lazyLoads.push({
                el: document.getElementById('message_' + message.id),
                onVisible: () => this.setState({visible: true})
            })
        }

        if (message.type === 'liveroom_card') {
            const liveroom = message.meta
            const {classroom} = this.context.classroomPage.props
            if (liveroom.id === classroom.liveroom.id && classroom.role.is_fans && account.subscribed) {
                this.setState({subscribed: true})
            }
        }
    }

    onEnter() {
        const {type, message} = this.props
        if (type === 'lecture_card') {
            const lecture = message.meta
            window.location = `/lecture/${lecture.id}`
        } else if (type === 'channel_card') {
            const channel = message.meta
            window.location = `/channel/${channel.id}`
        } else if (type === 'liveroom_card') {
            const liveroom = message.meta
            window.location = `/liveroom/${liveroom.id}`
        }
    }

    onPay() {
        const {type, message, lectureId} = this.props
        if (type === 'lecture_card') {
            const lecture = message.meta
            this.props.dispatch({
                type: 'PAY_LECTURE',
                payload: {
                    params: {
                        product: 'pay_lecture',
                        lecture_id: lecture.id,
                        fr: 'room',
                        chatid: lectureId,
                    },
                    succcess: () => {
                        this.setState({subscribed: true})
                    },
                    fail: (data) => {
                        if (data.code === 2) {
                            this.context.page.showToast('已购买课程')
                            this.setState({subscribed: true})
                        }
                    }
                }
            })
        } else if (type === 'channel_card') {
            const channel = message.meta
            this.props.dispatch({
                type: 'PAY_CHANNEL',
                payload: {
                    params: {
                        product: 'pay_channel',
                        channel_id: channel.id,
                        fr: 'room',
                        chatid: lectureId,
                    },
                    succcess: () => {
                        this.setState({subscribed: true})
                    },
                    fail: (data) => {
                        if (data.code === 2) {
                            this.context.page.showToast('已购买专栏')
                            this.setState({subscribed: true})
                        }
                    }
                }
            })
        }
    }

    onSubscribe() {
        const {type, message, account} = this.props
        if (type === 'lecture_card') {
            const lecture = message.meta

            axios.get(`/api/lecture/${lecture.id}/access`).then((response) => {
                if (response.data.code === 0) {
                    const {data} = response.data
                    if (data.lecture_access.subscribed && account.subscribed) {
                        this.context.page.showToast('已预约')
                        this.setState({subscribed: true})
                    } else {
                        axios.get(`/api/lecture/${lecture.id}/subscribe_qrcode`).then((res) => {
                            this.props.dispatch({
                                type: 'SHOW_SUBSCRIBE_LECTURE',
                                payload: {
                                    lecture: lecture,
                                    lectureQrcode: res.data.data.qrcode_content,
                                    callback: () => {
                                        this.setState({subscribed: true})
                                    }
                                }
                            })
                        })
                    }
                }
            })
        }
    }

    onFollowLiveroom() {
        const {message, account, lectureId} = this.props
        const liveroom = message.meta
        axios.get(`/api/liveroom/${liveroom.id}/info`).then((response) => {
            if (response.data.code === 0) {
                const {data} = response.data
                if (data.role.is_fans && account.subscribed) {
                    this.context.page.showToast('已关注')
                    this.setState({subscribed: true})
                } else {
                    this.props.dispatch({
                        type: 'SHOW_FOLLOW_LIVEROOM',
                        payload: {
                            liveroom: data.liveroom,
                            qrcodes: data.qrcodes,
                            lectureId: lectureId,
                            from: 'cardMessage',
                            callback: () => {
                                this.setState({subscribed: true})
                            }
                        }
                    })
                }
            }
        })
    }

    renderLectureCommand() {
        const {message} = this.props
        const lecture = message.meta
        if (this.state.subscribed) {
            return <PreviewButton primary onClick={this.onEnter}>查看</PreviewButton>
        }
        if (lecture.lecture_type === 'pay_lecture') {
            return <PreviewButton primary onClick={this.onPay}>立即购买</PreviewButton>
        } else if (lecture.lecture_type === 'open_lecture') {
            return <PreviewButton primary onClick={this.onSubscribe}>立即预约</PreviewButton>
        }
        return <PreviewButton primary onClick={this.onEnter}>查看</PreviewButton>
    }

    renderChannelCommand() {
        const {message} = this.props
        const channel = message.meta
        if (this.state.subscribed) {
            return <PreviewButton primary onClick={this.onEnter}>查看</PreviewButton>
        }
        if (channel.need_money) {
            return <PreviewButton primary onClick={this.onPay}>立即购买</PreviewButton>
        } else {
            return <PreviewButton primary onClick={this.onEnter}>查看</PreviewButton>
        }
    }

    renderLiveroomCommand() {
        if (this.state.subscribed) {
            return <PreviewButton primary onClick={this.onEnter}>查看</PreviewButton>
        }
        return <PreviewButton primary onClick={this.onFollowLiveroom}>关注</PreviewButton>
    }

    renderLectureCard() {
        const {message} = this.props
        const lecture = message.meta
        return <div className="lecture-card">
            <div className="info" onClick={this.onEnter}>
                <div>
                    <div className="cover left-side" style={{backgroundImage: `url(${lecture.cover_url})`}}>
                    </div>
                </div>
                <div className="right-side">
                    <p className="name">{lecture.name}</p>
                    <p className="meta">课程</p>
                </div>
            </div>
            <PreviewFooter>
                {this.renderLectureCommand()}
            </PreviewFooter>
        </div>
    }

    renderChannelCard() {
        const {message} = this.props
        const channel = message.meta
        return <div className="channel-card">
            <div className="info" onClick={this.onEnter}>
                <div >
                    <div className="cover left-side"
                         style={{backgroundImage: `url(${channel.cover_url || channel.cover})`}}>
                    </div>
                </div>
                <div className="right-side">
                    <p className="name">{channel.name}</p>
                    <p className="meta">专栏</p>
                </div>
            </div>
            <PreviewFooter>
                {this.renderChannelCommand()}
            </PreviewFooter>
        </div>
    }

    renderLiveroomCard() {
        const {message} = this.props
        const liveroom = message.meta
        return <div className="liveroom-card">
            <div className="info" onClick={this.onEnter}>
                <div>
                    <img className="left-side" src={liveroom.small_avatar_url || liveroom.avatar_url} alt="avatar"/>
                </div>
                <div className="right-side">
                    <p className="name">{liveroom.name}</p>
                    <p className="meta">直播间</p>
                </div>
            </div>
            <PreviewFooter>
                {this.renderLiveroomCommand()}
            </PreviewFooter>
        </div>
    }

    renderCard() {
        const {type} = this.props
        switch (type) {
            case 'lecture_card':
                return this.renderLectureCard()
            case 'channel_card':
                return this.renderChannelCard()
            case 'liveroom_card':
                return this.renderLiveroomCard()
            default:
                break;
        }
    }

    render() {
        try {
            return (
                <div className="card-content ">
                    {this.state.visible &&
                    this.renderCard()
                    }
                </div>
            )
        } catch(e) {
            return <ErrorMessage/>
        }
    }
}


CardMessage.contextTypes = {
    classroomPage: React.PropTypes.object,
    page: React.PropTypes.object
};


export default CardMessage = connect((state) => ({
    account: state.account,
    lectureId: state.classroom.lecture.id,
}))(CardMessage)




// WEBPACK FOOTER //
// ./src/components/messages/CardMessage.js